<template>
  <div class="notice_wrapper">
    <div class="notice_cont_outer" :style="{'background': '#fff url('+imgUrl+'poli_bg.png) no-repeat -25px -150px'}">
      <div class="notice_title">
        <div class="m_outer">
          <div class="m_title">惠企政策</div>
          <div class="m_tip">
            目前共有惠企政策<br/>
            {{all}}条
          </div>
        </div>
      </div>
    </div>
    <div class="cur_pos">当前位置：<span class="linkto" @click="tohome">首页</span><img :src="imgUrl+'double_arrow.png'"/><span class="linkto" @click="toPolicy">惠企政策</span><img :src="imgUrl+'double_arrow.png'"/><span>详情</span></div>

    <div class="notidetail_outer">
      <div class="notidetail_cont">
        <div class="head">
          <div class="tit">
            {{detail.post_title}}
          </div>
          <div class="info">

            <span v-if="detail.level" v-text="'政策层级：'+detail.level"></span>
            <span v-if="detail.policy" v-text="'政策类型：'+detail.policy"></span>
            <span v-if="detail.dept" v-text="'主管机关：'+detail.dept"></span>
            <span v-if="detail.end_time" v-text="'申报时限：'+detail.end_time"></span>
            <span v-if="detail.published_time" v-text="'发布时间：'+detail.published_time"></span>
          </div>
        </div>
        <div v-html="detail.post_content" class="paragraph">{{ detail.post_content }}</div>
        <div class="btn_outer btn_outer_fav">
          <el-button type="danger"  v-if="detail.followed" @click="cancelFav">
            <div>已关注</div>
            <i class="cloudicon ci_fav"></i></el-button>


          <el-button type="danger" plain @click="addToFav" v-if="!detail.followed">
            <div>关注</div>
            <i class="cloudicon ci_fav"></i></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    let id = this.$route.query.id;
    this.id=id;
    this.$ajax.get(this.bUrl+'api/portal/articles/read?id=' + id)
      .then(function (res) {
        this.detail=res.data.data;
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    this.getAll();
  },
  name: 'polidetail',
  data() {
    return {
      id:-1,
      detail: {
        post_title: '',
        published_time: '',
        post_content: '',
        level: '',
        dept: '',
      },

      all:0
    }
  },
  watch: {
    $route(to, from) {
      let id = to.query.id;
      this.id=id;
      this.$ajax.get(this.bUrl+'api/portal/articles/read?id=' + id)
        .then(function (res) {
          this.detail=res.data.data;
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      this.getAll();
    }
  },
  methods:{
  	toPolicy(){
    	this.$router.push({name:'policy'})
    },
    tohome() {
      this.$router.push({name: 'homepage'})
    },
    async addToFav() {
      let res = await this.$ajax.post(this.bUrl + '/api/portal/articles/dofavorite?id=' + this.id);
      if(res.data.code===200){
        this.$message.success(res.data.msg);
        this.detail.followed=true;
      }else{
        this.$message.error(res.data.msg);
      }
    },
    cancelFav(){
      this.$ajax.post(this.bUrl+'api/portal/articles/cancelfavorite?id=' + this.id)
				.then(function(res) {
          if(res.data.code==200){
            this.detail.followed = false
            this.$message.success(res.data.msg);
          }else {
            this.$message.error(res.data.msg);
          }
				}.bind(this))
				.catch(function(error) {
					console.log(error);
				});
    },
    async getAll(){
      let res = await this.$ajax.get(this.bUrl + 'api/portal/lists/policy?page=' + this.currentPage+"&pagesize=10");
      this.all = res.data.data.total;
    },

  }
}
</script>

<style scoped>
.notice_cont_outer {
  width: 1180px;
  margin: 0 auto;
}

.notice_title {
  height: 368px;
  display: flex;
  align-items: flex-end;
  position: relative;
}

.m_outer {
  padding: 20px;
}

.m_title {
  color: #143367;
  font-size: 28px;
  margin-bottom: 16px;
}

.m_tip {
  width: 160px;
  color: #2574AD;
  font-size: 14px;
  line-height: 24px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.notidetail_outer {
  background: #fff;
}

.notidetail_cont {
  width: 1180px;
  margin: 0 auto;
  padding:36px 66px;
  box-sizing: border-box;
  color: #666666;
  border: 1px solid #E1EAFA;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  /*margin-top: 64px;*/
}

.notidetail_cont .head {
  text-align: center;
  margin-bottom: 20px;
}

.notidetail_cont .head .tit {
  font-size: 24px;
  color: #5F5F5F;
}

.notidetail_cont .head .info {
  padding: 0 150px;
  display: flex;
  justify-content: space-around;
  line-height: 40px;
  font-size: 12px;
  color: #666666;
}

.notidetail_cont .paragraph {
  margin: 0 90px 60px 90px;
}
.btn_outer {
  text-align: center;
  font-size: 20px;
}

.btn_outer .ci_fav {
  margin-left: 10px;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/PreferentPolicy/polidetail.vue